import updateTreeState from './common/updateTreeState';

const initializeTree = (
  prevState,
  {
    treeId,
    models,
    selection,
    adapter,
    plugins,
    filter = null,
    context = null,
  },
) => {
  if (prevState[treeId]) {
    return prevState;
  }

  let treeState = {
    treeId,
    filter,
    context,
    inputModels: models,
    models: {},
    parents: {},
    children: { [null]: [] },
  };

  for (const plugin of Object.values(plugins)) {
    plugin.prepareTreeState &&
      plugin.prepareTreeState(treeState, { adapter, filter });
  }

  treeState = updateTreeState(treeState, models, {
    adapter,
    filter,
    context,
    plugins,
  });

  if (selection && plugins.selection) {
    plugins.selection.setSelection(treeState, selection, { adapter });
  }

  return {
    ...prevState,
    [treeId]: treeState,
  };
};
export default initializeTree;
